module.exports = __webpack_public_path__ + "img/deals.3d0cef17.svg";